module.exports = __webpack_public_path__ + "apollo.png?0497f25830c682381be972a996f7d827";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sad windows/apollo.png
// module id = 32
// module chunks = 0